import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const adminOrganizationStatisticsSlice = (state: RootState) => state.entities.adminOrganizationStatistics;

export const adminOrganizationStatisticsUpdatingStateById = selectorsFactory.createUpdatingStateByIdSelector(
  adminOrganizationStatisticsSlice,
);

export const adminOrganizationStatisticsStateById = selectorsFactory.createEntityStateByIdSelector(
  adminOrganizationStatisticsSlice,
);
